<template>
        <v-card class="elevation-10">
            <v-card-title>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                      <!-- client -->
                      <v-flex xs2>
                          <v-autocomplete
                                  v-model="cliente_id"
                                  :items="clients"
                                  label="Client"
                                  item-text="company_name"
                                  item-value="id"
                                  clearable
                          >
                          </v-autocomplete>
                      </v-flex>
                      <!-- status -->
                      <v-flex xs2>
                          <v-autocomplete
                                  v-model="status_id"
                                  :items="statuses"
                                  label="Statuses"
                                  item-text="name"
                                  item-value="id"
                                  clearable
                          >
                          </v-autocomplete>
                      </v-flex>

                      <!-- account manager -->
                      <v-flex xs2>
                          <v-autocomplete
                                  v-model="account"
                                  :items="accounts"
                                  label="Account manager"
                                  item-text="account_manager"
                                  item-value="account_manager"
                                  clearable
                          >
                          </v-autocomplete>
                      </v-flex>

                      <!-- country -->
                      <v-flex xs2>
                          <v-autocomplete
                                  :items="paises"
                                  item-text="name"
                                  label="Country"
                                  item-value="id"
                                  v-model="pais"
                                  clearable
                          ></v-autocomplete>
                      </v-flex>

                      <!-- sample -->
                      <v-flex xs2>
                          <v-autocomplete
                                  :items="samples_to_select"
                                  item-text="name"
                                  label="Sample"
                                  item-value="id"
                                  v-model="sample_id"
                                  clearable
                          ></v-autocomplete>
                      </v-flex>



                    </v-layout>
                    <v-layout row wrap>
                      <!-- from -->
                      <v-flex md2 xs2>

                        <v-menu
                          :close-on-content-click="false"
                          v-model="menu_from"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                                  v-validate="''"
                                  slot="activator"
                                  v-model="from"
                                  label="From"
                                  data-vv-name="from"
                                  readonly
                                  browser-autocomplete="off"
                                  clearable
                          ></v-text-field>
                          <v-date-picker v-model="from" @input="fromOnChange"></v-date-picker>
                        </v-menu>
                      </v-flex>

                        <!-- to -->
                        <v-flex md2 xs2>

                          <v-menu
                          :close-on-content-click="false"
                          v-model="menu_to"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                          >
                          <v-text-field
                                  v-validate="''"
                                  slot="activator"
                                  v-model="to"
                                  data-vv-name="to"
                                  label="To"
                                  readonly
                                  browser-autocomplete="off"
                                    clearable
                          ></v-text-field>
                          <v-date-picker v-model="to" @input="toOnChange"></v-date-picker>
                          </v-menu>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end>

                      <!-- search -->
                      <v-flex xs4>
                          <v-text-field
                                  v-model="search"
                                  append-icon="search"
                                  label="Search"
                          ></v-text-field>
                      </v-flex>

                      <!-- per page -->
                      <v-flex xs1 sm1 d-flex>
                        <v-select
                          :items="[10, 15, 25, 35, 50 ,60]"
                          label="Per page"
                          v-model="per_page"
                          @change="getSamples"
                        ></v-select>
                      </v-flex>

                      <!-- export -->
                      <v-flex xs2>
                        <v-btn :href="BASE + 'sample-orders/export?status_id=' + status_id
                                                                  + '&account=' + account
                                                                  + '&pais=' + pais
                                                                  + '&client_id=' + cliente_id
                                                                  + '&search=' + search
                                                                  + '&sample_id=' + sample_id
                                                                  + '&sortBy=' + sortBy
                                                                  + '&order=' + order
                                                                  + '&download_token=' + download_token" target="_blank"
                          >
                            Export
                          </v-btn>
                      </v-flex>
                    </v-layout>
                </v-container>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="samples.data"
                    :search="search"
                    :pagination.sync="pagination"
                    hide-actions
                    :loading="loading"
                    :total-items="8"
                    v-on:update:pagination="ordenar"
            >
                <template slot="items" slot-scope="props">
                    <tr :class="{ 'light-green accent-1': props.item.feedback }">
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)">{{ props.item.request_ }}</td>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.client_company_name }}</td>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.account_manager }}</td>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.status_name }}</td>
                        <td class="text-xs">{{ props.item.track_number }}</td>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.date }}</td>
                        <td class="layout px-0 align-center">
                            <v-menu
                                    transition="slide-y-transition"
                                    bottom
                                    left
                            >
                                <v-btn
                                        slot="activator"
                                        color="primary"
                                        dark
                                        fab
                                        flat
                                >
                                    <v-icon>settings</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile>
                                        <v-btn
                                                flat block
                                                :href="BASE + 'sample-order/' + props.item.id + '?download_token=' + download_token"
                                                target="_blank"
                                        >
                                            <v-icon left>assignment</v-icon>
                                            Download sample request
                                        </v-btn>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-btn flat block v-on:click="copyItem(props.item.id)"><v-icon left>file_copy</v-icon>Copy</v-btn>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>delete</v-icon>Delete</v-btn>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
            <div class="text-xs-center pt-4 pb-4" v-if="samples.data">
                <v-pagination
                        v-model="page"
                        :length="last_page"
                        color="secondary"
                        circle
                        :total-visible="7"
                        @input="setPage"
                ></v-pagination>
                <p class="subtitle">Showing {{ samples.meta.from }} to {{ samples.meta.to }} of {{ samples.meta.total }} entries</p>
            </div>
        </v-card>
</template>

<script>
    import { BASE } from '../../../config.js';

    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {sortBy: 'created_at', descending: true},
                loading: false,
                headers: [
                    {
                        text: 'Sample request',
                        align: 'left',
                        sortable: true,
                        value: 'request_'
                    },
                    { text: 'Client', value: 'client_id', sortable: true },
                    { text: 'Account Manager', value: 'account_manager', sortable: true },
                    { text: 'Status', value: 'status_id', sortable: true },
                    { text: 'Tracking number', value: 'track_number', sortable: true },
                    { text: 'Date', value: 'date', sortable: true },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                samples: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                clients: null,
                statuses: null,
                cliente_id: null,
                status_id: null,
                BASE: BASE,
                sortBy: 'created_at',
                order: 'desc',
                per_page: 25,
                accounts: null,
                account: null,
                paises: null,
                pais: null,
                download_token: null,
                menu_from : false,
                from : null,
                menu_to : false,
                to : null,
                samples_to_select : [],
                sample_id : null
            }
        },
        created: function() {
            this.checkUser();
            this.getCountries();
            this.setSectionTitle();
            this.getClients();
            this.getStatuses();
            this.getSelectAccountManager();
            this.setQueryParams();
            this.getSamples();
            this.getSamplesToSelect();
            this.debouncedGetSamples = _.debounce(this.getSamples, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.page = 1;
                this.$router.push({ query: Object.assign({}, this.$route.query, { search: this.search }) });
                this.debouncedGetSamples();
            },
            last_page: function () {
                if (this.page > this.samples.meta.last_page) {
                    this.page = 1;
                }
            },
            cliente_id: function () {
                if (this.cliente_id == undefined) {
                    this.cliente_id = null;
                }

                this.$router.push({ query: Object.assign({}, this.$route.query, { cliente_id: this.cliente_id }) });

                this.page = 1;
                this.debouncedGetSamples();
            },
            status_id: function () {
                if (this.status_id == undefined) {
                    this.status_id = null;
                }
                this.page = 1;

                this.$router.push({ query: Object.assign({}, this.$route.query, { status_id: this.status_id }) });

                this.debouncedGetSamples();
            },
            account: function () {
                if (this.account == undefined) {
                    this.account = null;
                }
                this.page = 1;

                this.$router.push({ query: Object.assign({}, this.$route.query, { account: this.account }) });

                this.debouncedGetSamples();
            },
            pais: function () {
                if (this.pais == undefined) {
                    this.pais = null;
                }
                this.page = 1;
                this.$router.push({ query: Object.assign({}, this.$route.query, { pais: this.pais }) });
                this.debouncedGetSamples();
            },

            to : function(){
              if(this.to == undefined){
                this.to = null;
              }

              this.page = 1;
              this.$router.push({ query: Object.assign({}, this.$route.query, { to: this.to }) });
              this.debouncedGetSamples();

            },

            from : function(){
              if(this.from == undefined){
                this.from = null;
              }

              this.page = 1;
              this.$router.push({ query: Object.assign({}, this.$route.query, { from: this.from }) });
              this.debouncedGetSamples();

            },

            sample_id : function(){
              if(this.sample_id == undefined){
                this.sample_id = null;
              }

              this.page = 1;
              this.$router.push({ query: Object.assign({}, this.$route.query, { sample_id: this.sample_id }) });
              this.debouncedGetSamples();
            },

            page: function () {
                this.$router.push({ query: Object.assign({}, this.$route.query, { page: this.page }) });
            },
        },
        methods : {
            setQueryParams() {
                if (this.$route.query.search) {
                    this.search = this.$route.query.search;
                }
                if (this.$route.query.cliente_id) {
                    this.cliente_id = parseInt(this.$route.query.cliente_id);
                }
                if (this.$route.query.status_id) {
                    this.status_id = parseInt(this.$route.query.status_id);
                }
                if (this.$route.query.account) {
                    this.account = this.$route.query.account;
                }
                if (this.$route.query.pais) {
                    this.pais = parseInt(this.$route.query.pais);
                }
                if (this.$route.query.page) {
                    this.page = parseInt(this.$route.query.page);
                }

                if(this.$route.query.to){
                  this.to = this.$route.query.to;
                }

                if(this.$route.query.from){
                  this.from = this.$route.query.from;
                }
            },
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            ver(id, blank) {
                if (blank) {
                    let route = this.$router.resolve({ name: 'admin.samples.detail', params : { id : id } });
                    window.open(route.href, '_blank');
                } else {
                    this.$router.push({ name: 'admin.samples.detail', params : { id : id } });
                }

            },
            getCountries () {
                this.$store.dispatch('getSelectCountry').then((res) => {
                    this.paises = res.data;
                }).catch((error) => {

                });
            },
            getSamplesToSelect () {

                this.$store.dispatch('samplesToSelect', { search : null }).then((res) => {
                    this.samples_to_select = res.data.data;
                }).catch((error) => {
                  console.log(error);
                });
            },
            getSelectAccountManager () {
                this.$store.dispatch('getSelectAccountManager', {}).then((res) => {
                    this.accounts = res.data;
                }).catch((error) => {

                });
            },
            ordenar (payload) {
                this.loading = true;
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getSamples();
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Samples requests list.'
                });
            },
            getStatuses () {
                this.$store.dispatch('getStatusSampleOrders').then((res) => {
                    this.statuses = res.data.data;
                }).catch((error) => {

                });
            },
            getClients () {
                this.$store.dispatch('getClientsSelect').then((res) => {
                    this.clients = res.data;
                }).catch((error) => {

                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteSampleOrder', {
                            id: id
                        }).then((res) => {

                            this.getSamples();

                        }).catch((error) => {

                        });
                    }
                })
            },
            copyItem (id) {
                this.$store.dispatch('copySampleOrder', {
                    id: id
                }).then((res) => {

                    this.getSamples();

                }).catch((error) => {

                });
            },
            setPage (page) {
                this.page = page;
                this.getSamples();
            },

            toOnChange () {
              this.menu_to = false;
              //this.getSamples();
            },

            fromOnChange () {
              this.menu_from = false;
              //this.getSamples();
            },

            getSamples () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        client_id: this.cliente_id,
                        status_id: this.status_id,
                        sortBy: this.sortBy,
                        order: this.order,
                        account: this.account,
                        pais: this.pais,
                        per_page: this.per_page,
                        to : this.to,
                        from : this.from,
                        sample_id : this.sample_id
                    }
                };
                this.$store.dispatch('getSamples', params).then((res) => {

                    this.samples = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/samples/ListComponent.vue